import MainLayout from "@/layout/MainLayout.vue";
export default [
  {
    path: "/set",
    component: MainLayout,
    name: "set",
    redirect: "/set/userList",
    meta: {
      title: "系统设置",
      icon: "setting",
    },
    // hidden: true,
    children: [
      {
        path: "/set/userList",
        name: "userList",
        component: () => import("@/views/Set/User"),
        meta: {
          title: "账户管理",
        },
      },
      {
        path: "/set/roleList",
        name: "roleList",
        component: () => import("@/views/Set/Role"),
        meta: {
          title: "角色权限",
        },
      },
      {
        path: "/set/dictionaryList",
        name: "dictionaryList",
        component: () => import("@/views/Set/Dictionary"),
        meta: {
          title: "数据字典",
        },
      },
    ],
  },
];
